import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { ReactElement } from "react";

import {
  COURSES_CALENDAR_TOOLBAR_SELECT_DEFAULT_MIN_WIDTH,
  ICoursesCalendarToolbarSelectOption,
  pickAllowedToolbarSelectValue,
} from "./parts";

interface ICoursesCalendarToolbarSelectProps<T extends string> {
  value: T;
  options: readonly ICoursesCalendarToolbarSelectOption<T>[];
  allowedValues: readonly T[];
  onValueChange: (value: T) => void;
  className?: string;
  "data-e2e"?: string;
  minWidth?: number;
}

export const CoursesCalendarToolbarSelect = <T extends string>({
  value,
  options,
  allowedValues,
  onValueChange,
  className,
  "data-e2e": dataE2e,
  minWidth = COURSES_CALENDAR_TOOLBAR_SELECT_DEFAULT_MIN_WIDTH,
}: ICoursesCalendarToolbarSelectProps<T>): ReactElement => {
  const handleChange = (event: SelectChangeEvent<T>): void => {
    const matched = pickAllowedToolbarSelectValue(
      event.target.value,
      allowedValues,
    );
    if (matched !== undefined) {
      onValueChange(matched);
    }
  };

  return (
    <FormControl
      className={className}
      size="small"
      variant="standard"
      sx={{ minWidth }}
    >
      <Select value={value} onChange={handleChange} data-e2e={dataE2e}>
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
